const CLASSES = {
    entered: 'input--entered'
};

const TYPES = {
    checkbox: 'checkbox',
    text: 'text'
};

class Input {
    constructor(el) {
        this.el = el;
        this.inputEl = el.find('input, textarea, select');
        this.labelEl = el.find('.input__label');

        this.type = TYPES.text;
        this.inputEl.data('placeholder', this.inputEl.prop('placeholder'));

        /**
     * Events
     */

        this.inputEl.on('change', () => {
            let active = this.inputEl.val() !== '';

            this.el.toggleClass(CLASSES.entered, active);
        });

        this.inputEl.on('focus', () => {
            this.inputEl.prop('placeholder', '');
        });
        this.inputEl.on('blur', () => {
            this.inputEl.prop('placeholder', this.inputEl.data('placeholder'));
        });
    }
}

export default Input;